<template>
  <div class="mb-2"  >
    <div class="bloco-informativo">
      <div class="bloco-itens item-atalho" v-for="card in dados.cardsInfo" :key="card.id">
        <div>
          <v-card class="rounded-sm" :color="card.color"  >
                  <v-row align="center" class="ms-4" no-gutters >
                      <v-col no-gutters>
                        <v-row class="text-h4 white--text" no-gutters>
                            {{ card.quantidade }}
                        </v-row>
                        <v-row class="text-body-2 white--text" no-gutters>
                          {{ card.descricao }}
                        </v-row>
                      </v-col>
                      <v-col align="end" class="me-4 ">
                          <v-icon size="80" class="icone" >
                              {{ card.icone }}
                              <!-- timer -->
                              <!-- av_timer -->
                              <!-- calendar_month -->
                              <!-- hourglass_empty -->
                              <!-- hourglass_top -->
                              <!-- hourglass_bottom -->
                          </v-icon>
                      </v-col>
                  </v-row>
              </v-card>
        </div>
      </div>
    </div>

    <div class="bloco-informativo">
      <div class="bloco-itens itens-second-1">
        <Window title="Média das Turmas" borderColor="#8E24AA">
          <v-tabs>
            <v-tab>Notas</v-tab>
            <v-tab>Conceitos</v-tab>
            <v-tab-item>
              <v-card class="pa-3">
                <MediaTurmas :height="290" :dados="dados.grafico"/>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="pa-3" style="overflow: hidden scroll;height: 322px;">
                <div v-if="this.possuiConceito">
                  <span>Nenhum conceito encontrado!</span>
                </div>
                <div v-else v-for="(linha, index) in dados.grafico2" :key="index">
                  <span>{{linha.turma.nmturma}} - {{linha.disciplina.dsdiscipl}}</span>
                  <div style="display:flex; align-items:center">
                    <v-progress-linear
                      :color="setCor(linha.mediaN.valorconceito)"
                      height="5"
                      value="100"
                      style="width:90%"
                    ></v-progress-linear>
                    <div style="width:10%; text-align:center">{{linha.mediaN.valorconceito}}</div>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </Window>
      </div>
      <div class="bloco-itens itens-second-2">
        <Window title="Aulas Lecionadas" borderColor="#1B5E20">
          <div class="aulas-lecionadas-progress">
            <div
              class="aulas-lecionadas-periodo"
              v-for="progress in dados.aulasProgress"
              :key="progress.id"
            >
              <div>
                <div class="aulas-lecionadas-progress-title">
                  <div>
                    <strong>{{ progress.descricao }}</strong>
                  </div>
                  <div>
                    <strong>{{ progress.valorAtual }}</strong>
                    /{{ progress.valorFinal }}
                  </div>
                </div>
                <v-progress-linear
                  style="margin: 4px 0px"
                  :color="progress.color"
                  height="12"
                  :value="(progress.valorAtual * 100) / progress.valorFinal"
                />
              </div>
            </div>
          </div>
        </Window>
      </div>
    </div>

    <div class="bloco-informativo">
      <div class="bloco-itens" style="width: 100%">
        <Window title="Calendário Escolar" borderColor="#F4511E" maxHeight="500px">
          <TimeLineProfessor :events="dados.timeline"/>
        </Window>
      </div>
    </div>
  </div>
</template>

<script>
import Window from "./Window";
import TimeLineProfessor from "./TimeLineProfessor";
import MediaTurmas from "./charts/MediaTurmas";

export default {
  name: "HomeProfessor",
  components: {
    Window,
    TimeLineProfessor,
    MediaTurmas,
  },
  props: {
    dados: {
      type: Object,
      default() {
        return {
          cardsInfo: [],
          aulasProgress: [],
          timeline: [],
          grafico: {},
          grafico2: {}
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    setCor(conceito) {
      let cor;
      switch (conceito.trim()) {
        case "A":
          cor = "#008000";
          break;
        case "B":
          cor = "#FFA500";
          break;
        case "C":
          cor = "#FFFF00";
          break;
        case "D":
          cor = "#FF0000";
          break;
        case "E":
          cor = "#DEB887";
          break;
        default:
          cor = "#F0F8FF";
          break;
      }
      return cor;
    }
  },
  computed: {
    possuiConceito(){
      if(this.dados.grafico2)
        return this.dados.grafico2.length == 0
    }
  },
};
</script>

<style lang="scss" scope>
</style>
